import { render, staticRenderFns } from "./Liker.vue?vue&type=template&id=550425bc&lang=pug&"
import script from "./Liker.vue?vue&type=script&lang=js&"
export * from "./Liker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports